import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { igolfMappingRequest } from "API/apiConfig";
import { DrivingRangeList } from "API/apiRequest";

const initialState = {
    status: "idle",
    driving_range_status: "idle",
    driving_range_data: {},
    rangeName: null
  };

  export const drivingRange_list = createAsyncThunk(
    "/DrivingRange",
    async ({body,user}) => {
  
      let res =await igolfMappingRequest(
        DrivingRangeList,
         body, user)
          .then((res) => res)
          .catch((error) => error);
        let resData = {data:res?.data};
        return resData;
    }
  );


  export const DrivingRangeSlice = createSlice({
    name: "Drivingrange",
    initialState,
    reducers: {
      clearDrivingRangeList: (state,action) => {
        state.driving_range_data = initialState.driving_range_data;
      },
      // for input field of DrivingRangeList
      searchRangeName: (state,action) => {
        state.rangeName = action?.payload;
      },
      clearsearchRangeName: (state,action) => {
        state.rangeName = initialState.rangeName;
      },
    },
    extraReducers: (builder) => {
      builder
        
        .addCase(drivingRange_list.pending, (state) => {
          state.driving_range_status = "loading";
        })
        .addCase(drivingRange_list.fulfilled, (state, { payload }) => {
          state.driving_range_status = "idle";
          state.driving_range_data =  payload?.data;
        })
        .addCase(drivingRange_list.rejected, (state) => {
          state.driving_range_status = "idle";
        })

    },
  });
  
  export const { clearDrivingRangeList,searchRangeName ,clearsearchRangeName
  } = DrivingRangeSlice.actions;
  
  export default DrivingRangeSlice.reducer;